<div class="modal-container">
  <div class="modal-header">
    <h2 class="modal-title">Welcome back!</h2>
  </div>

  <div class="modal-body">
    <p class="visible-sm-block visible-md-block visible-lg-block">You are already registered with us.<br> Please enter the OTP we have sent to your registered mobile number
      {{data.phoneNumber}}</p>
    <p class="visible-xs-block">You are already registered with us. Please enter the OTP we have sent to your registered mobile number
      {{data.phoneNumber}}</p>
    <mat-form-field class="input-field">
      <input matInput #otp placeholder="Enter the OTP" [maxLength]="6" type="password" />
    </mat-form-field>
    <small id="resend-otp-disabled" *ngIf="!isOtpResent">Resend OTP</small>
    <small id="resend-otp-enabled" *ngIf="isOtpResent" (click)="resendOtp();(otp.value='')">Resend OTP</small>
    <small id="invalid-otp" *ngIf=otpErrorMessage>{{otpErrorMessage}}</small>
  </div>

  <div class="modal-footer">
    <button type="button" [disabled]="(otp.value.toString().length !== 6)" (click)="onSubmit(otp.value)">Continue
    </button>
  </div>
</div>
